export const vendureCacheConfig = {
  staleTime: 2 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  retry: 1,
} as const;
